export const environment = {
    production: false,
    backendUrl: "https://gcp-operations-backend-776893046318.us-central1.run.app",
    firebase: {
        apiKey: "AIzaSyC0ld2noUTbZ4EGTxHKBlnGckYmq7cqbxc",
        authDomain: "gcp-operations-staging-bb9f8.firebaseapp.com",
        projectId: "gcp-operations-staging-bb9f8",
        storageBucket: "gcp-operations-staging-bb9f8.appspot.com",
        messagingSenderId: "776893046318",
        appId: "1:776893046318:web:7fcb9f2d7c8dc45b9389bf",
        measurementId: "G-22650WPJ58"
    },
    reCaptchaKey: "6LdcbW4qAAAAAKzOAt8SDr00A5jnhynBLTbICMcJ",
    appName: "AeroStar Dynamics Staging Env"
};
